<span class="text"><slot></slot></span>